import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalHeader, Nav, NavItem, NavLink } from "reactstrap";

import { Unit } from "../../../services/unitService";
import ImportBrazilianHolidaysModal, {
  BrazilianHolidaysImportSummary,
} from "./ImportBrazilianHolidaysModal";
import ImportBrazilianRegionalHolidaysModal, {
  BrazilianRegionalHolidaysImportSummary,
} from "./ImportBrazilianRegionalHolidaysModal";

type WizardTab = "national" | "regional";

interface ImportBrazilHolidaysWizardModalProps {
  isOpen: boolean;
  units: Unit[];
  submitting: boolean;
  initialYear?: number;
  initialTab?: WizardTab;
  onClose: () => void;
  onSubmittingChange: (value: boolean) => void;
  onNationalImported: (summary: BrazilianHolidaysImportSummary) => void;
  onRegionalImported: (summary: BrazilianRegionalHolidaysImportSummary) => void;
}

const ImportBrazilHolidaysWizardModal = ({
  isOpen,
  units,
  submitting,
  initialYear,
  initialTab = "national",
  onClose,
  onSubmittingChange,
  onNationalImported,
  onRegionalImported,
}: ImportBrazilHolidaysWizardModalProps) => {
  const { t } = useTranslation();
  const [tab, setTab] = useState<WizardTab>(initialTab);

  useEffect(() => {
    if (isOpen) {
      setTab(initialTab);
    }
  }, [initialTab, isOpen]);

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered size="lg">
      <ModalHeader toggle={onClose}>
        {t("studio.settings.calendar_exceptions.brHolidays.wizard.title")}
      </ModalHeader>
      <ModalBody>
        <Nav tabs className="mb-3">
          <NavItem>
            <NavLink
              href="#"
              className={tab === "national" ? "active" : ""}
              onClick={(event) => {
                event.preventDefault();
                setTab("national");
              }}
            >
              {t("studio.settings.calendar_exceptions.brHolidays.wizard.tabNational")}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              href="#"
              className={tab === "regional" ? "active" : ""}
              onClick={(event) => {
                event.preventDefault();
                setTab("regional");
              }}
            >
              {t("studio.settings.calendar_exceptions.brHolidays.wizard.tabRegional")}
            </NavLink>
          </NavItem>
        </Nav>

        <ImportBrazilianHolidaysModal
          isOpen={isOpen && tab === "national"}
          embedded
          units={units}
          submitting={submitting}
          initialYear={initialYear}
          onClose={onClose}
          onSubmittingChange={onSubmittingChange}
          onImported={onNationalImported}
        />

        <ImportBrazilianRegionalHolidaysModal
          isOpen={isOpen && tab === "regional"}
          embedded
          units={units}
          submitting={submitting}
          initialYear={initialYear}
          onClose={onClose}
          onSubmittingChange={onSubmittingChange}
          onImported={onRegionalImported}
        />
      </ModalBody>
    </Modal>
  );
};

export default ImportBrazilHolidaysWizardModal;
